class AnnouncementSlider extends HTMLElement {
  constructor() {
    super();
    this.slides = Array.from(this.querySelectorAll('.slideshow__slide'));
    this.nextBtn = this.querySelector('[name="next"]');
    this.prevBtn = this.querySelector('[name="previous"]');
    this.currentIndex = 0;
    
    // Auto-rotate settings
    this.autoRotate = this.dataset.autoplay === 'true';
    this.speed = parseInt(this.dataset.speed || 5) * 1000;
    this.interval = null;

    if (this.slides.length < 2) return;

    // Apply base styles for fading
    this.slides.forEach((slide, index) => {
      slide.style.position = index === 0 ? 'relative' : 'absolute';
      slide.style.top = '0';
      slide.style.left = '0';
      slide.style.width = '100%';
      slide.style.transition = 'opacity 0.5s ease-in-out';
      slide.style.opacity = index === 0 ? '1' : '0';
      slide.style.pointerEvents = index === 0 ? 'auto' : 'none';
      if (index !== 0) slide.setAttribute('aria-hidden', 'true');
    });

    this.nextBtn?.addEventListener('click', () => this.navigate(1));
    this.prevBtn?.addEventListener('click', () => this.navigate(-1));

    if (this.autoRotate) {
      this.play();
      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.play());
      
      // Also pause when interacting with buttons to avoid flashes
      this.nextBtn?.addEventListener('mouseenter', () => this.pause());
      this.prevBtn?.addEventListener('mouseenter', () => this.pause());
    }
  }

  navigate(direction) {
    if (this.slides.length < 2) return;

    // Fade out current
    this.slides[this.currentIndex].style.opacity = '0';
    this.slides[this.currentIndex].style.pointerEvents = 'none';
    this.slides[this.currentIndex].setAttribute('aria-hidden', 'true');
    this.slides[this.currentIndex].style.position = 'absolute';

    // Calculate next index
    this.currentIndex = (this.currentIndex + direction + this.slides.length) % this.slides.length;

    // Fade in next
    this.slides[this.currentIndex].style.opacity = '1';
    this.slides[this.currentIndex].style.pointerEvents = 'auto';
    this.slides[this.currentIndex].setAttribute('aria-hidden', 'false');
    this.slides[this.currentIndex].style.position = 'relative'; // restore layout flow height
  }

  play() {
    if (!this.interval) {
      this.interval = setInterval(() => this.navigate(1), this.speed);
    }
  }

  pause() {
    clearInterval(this.interval);
    this.interval = null;
  }
}

customElements.define('announcement-slider', AnnouncementSlider);
